var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffAccessOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 34.7065C26.2772 35.8556 23.7307 36.5 21 36.5C12 36.5 5 29.5 5 20.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.4 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7332 23.5C36.9086 22.5311 37 21.5286 37 20.5C37 11.5 30 4.5 21 4.5C19.2449 4.5 17.5659 4.7662 16 5.26153",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1.4 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6817 19.6502C22.38 19.6502 23.7568 18.2735 23.7568 16.5751C23.7568 14.8768 22.38 13.5 20.6817 13.5C18.9833 13.5 17.6066 14.8768 17.6066 16.5751C17.6066 18.2735 18.9833 19.6502 20.6817 19.6502Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.019H14.2925C13.5136 28.019 12.8929 27.5061 13.0155 26.8812C13.399 24.9276 14.8846 21.1436 20.6394 21.1436C23.6922 21.1436 25.5437 22.2084 26.6665 23.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23.5H26C25.4477 23.5 25 23.9477 25 24.5V30.5C25 31.0523 25.4477 31.5 26 31.5H36C36.5523 31.5 37 31.0523 37 30.5V24.5C37 23.9477 36.5523 23.5 36 23.5Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.3H28.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.5L27 27",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 29.7H35",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 28L35 29.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31.5V33.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 33.5H33.5",
    stroke: "#F4F4F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7205 15.625C13.143 15.2438 13.9872 13.7816 13.6061 12.359C13.2249 10.9364 11.7627 10.0922 10.3401 10.4734C8.91751 10.8546 8.07329 12.3168 8.45447 13.7394C8.83564 15.162 10.2979 16.0062 11.7205 15.625Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2103 13.8661C19.2125 13.7979 19.2097 13.7338 19.2015 13.6715C19.1462 13.2508 18.9258 12.8693 18.5887 12.6111C18.4348 12.4933 18.241 12.4114 17.9503 12.322",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9503 12.322C17.523 12.1906 17.1829 11.8628 17.0673 11.4315C16.9518 11.0002 17.0825 10.5464 17.3867 10.2189C17.5938 9.99607 17.7208 9.82837 17.7951 9.64928C17.9579 9.25716 17.9581 8.81661 17.7957 8.42458C17.6738 8.13056 17.4099 7.86707 16.8821 7.3401C16.3544 6.81311 16.0904 6.54962 15.796 6.42794C15.4034 6.26569 14.9622 6.26589 14.5694 6.42847C14.3902 6.50267 14.2222 6.6294 13.999 6.83616C13.6711 7.14002 13.2165 7.27048 12.7846 7.15508C12.3526 7.03971 12.0243 6.7001 11.8928 6.27344C11.8032 5.98316 11.7212 5.78966 11.6032 5.63603C11.3446 5.29943 10.9626 5.07933 10.5413 5.0241C10.2252 4.98271 9.86456 5.07934 9.1432 5.27263C8.42185 5.46591 8.06121 5.56255 7.80818 5.75643C7.47089 6.01493 7.25013 6.39655 7.19446 6.81734C7.16906 7.00942 7.19485 7.21798 7.26244 7.51417C7.36178 7.94945 7.24728 8.40766 6.93093 8.72354C6.61459 9.0394 6.1557 9.15373 5.71977 9.05455C5.42314 8.98705 5.21427 8.96129 5.0219 8.98667C4.60048 9.04224 4.21829 9.26268 3.9594 9.59949C3.76524 9.85209 3.66845 10.2122 3.47488 10.9325C3.28131 11.6528 3.18452 12.0129 3.226 12.3285C3.2813 12.7492 3.50173 13.1306 3.83882 13.3889C3.99268 13.5067 4.18644 13.5885 4.47712 13.6779C4.90445 13.8094 5.24459 14.1372 5.36012 14.5685C5.47566 14.9998 5.34501 15.4537 5.04068 15.7811C4.83364 16.004 4.70671 16.1718 4.63239 16.3508C4.46956 16.7429 4.46936 17.1834 4.63185 17.5755C4.7537 17.8695 5.0176 18.133 5.54537 18.66C6.07314 19.1869 6.33704 19.4505 6.63148 19.5721C7.02408 19.7343 7.46528 19.7341 7.85804 19.5716C8.03731 19.4974 8.20531 19.3706 8.42845 19.1639C8.7564 18.86 9.21101 18.7296 9.64292 18.845C10.0748 18.9604 10.4031 19.2999 10.5348 19.7267C10.6243 20.0169 10.7063 20.2104 10.8243 20.3641C11.0829 20.7006 11.4649 20.9208 11.8862 20.976C12.2023 21.0174 12.563 20.9207 13.2843 20.7274C14.0057 20.5342 14.3663 20.4375 14.6193 20.2437C14.9566 19.9852 15.1774 19.6035 15.233 19.1828C15.2584 18.9907 15.2327 18.7821 15.1651 18.4859C15.0657 18.0506 15.1802 17.5924 15.4965 17.2765C15.8128 16.9606 16.2718 16.8463 16.7078 16.9455C17.0044 17.0129 17.2132 17.0386 17.4055 17.0133C17.5067 16.9999 17.6056 16.9771 17.701 16.9455",
    stroke: "#F4F4F9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffAccessOverview);
export default __webpack_public_path__ + "static/media/StaffAccessOverview.c940f57cce7e9929bc6a4e55cc5c09fe.svg";
export { ForwardRef as ReactComponent };